import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { onDashboardMenuSelected } from "DashboardActions";
import { analyticsViewList } from "DashboardUserAction";
import {
  DASHBOARD_USERS,
  DASHBOARD_USERSCOUNT,
  DASHBOARD_DEVICE,
  DASHBOARD_NETWORKING,
  DASHBOARD_SESSIONS,
  DASHBOARD_ATTENDEES,
  DASHBOARD_ATTENADOPRATE,
  DASHBOARD_ATTEDENGARATE,
  DASHBOARD_INTERACTION,
  DASHBOARD_MESSAGESS,
  APPUSER_NOT_LOGIN_USERSCOUNT,
} from "DashboardActions";
import { loadConfirmationButton } from "BaseFunctions";
import { IMAGE_PATH, isTablet } from "Constants";
import AppIcons from "AppIcons";
import LocaleStrings from "Languages";

const activeTabsList = [
  DASHBOARD_DEVICE,
  DASHBOARD_SESSIONS,
  DASHBOARD_NETWORKING,
];

class DashboardMenuIcon extends Component {
  constructor(props) {
    super(props);
    this.onMenuSelected = this.onMenuSelected.bind(this);

    this.confirmButtonOk = React.createRef();
  }

  onMenuSelected() {
    this.props.onDashboardMenuSelected(this.props.menu);
  }

  openLink(key, list, counts) {
    let payload = {};
    payload.showModal = true;
    payload.key = key;
    payload.userList = list;
    payload.count = counts;
    payload.title =
      key == APPUSER_NOT_LOGIN_USERSCOUNT
        ? "Users who didn't login yet on the app"
        : "Users who login to the app atleast ones";
    this.props.analyticsViewList(payload);
  }

  // Function to disable confirmation button after ok click
  loadConfirmation = () => {
    // console.log(this.confirmButtonOk);

    loadConfirmationButton(this.confirmButtonOk);
  };

  JSONToCSVConvertor(JSONData) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var XLSX = require("xlsx");

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "usernotloggedin.xlsx");
  }

  exportUserData = () => {
    let { totalUsernotLoginCount } = this.props;
    // console.log(totalUsernotLoginCount);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>
              {LocaleStrings.analytics_dashboard_export_not_loggedin_user_title}
            </h1>
            <p>
              {
                LocaleStrings.analytics_dashboard_export_not_loggedin_user_subtitle
              }
            </p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.loadConfirmation();

                  let excelArr = [];
                  _.forEach(totalUsernotLoginCount.userList, (value, index) => {
                    let fname = value.firstname;
                    let lname = value.lastname;
                    let email = value.email;

                    let obj = {
                      "First Name": fname,
                      "Last Name": lname,
                      Email: email,
                    };

                    excelArr.push(obj);
                  });

                  if (!_.isEmpty(excelArr)) {
                    let data = {
                      "Users Not Loggedin": excelArr,
                    };
                    this.JSONToCSVConvertor(data);
                  } else {
                    this.props.showError(LocaleStrings.no_data_found);
                  }
                  onClose();
                }}
                ref={this.confirmButtonOk}
              >
                {LocaleStrings.button_download}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  render() {
    // var isSelected = `${this.props.selected == true ? "active" : ""}`;

    //if(this.props.menu.key)

    if (_.includes(activeTabsList, this.props.menu.key)) {
      var cursorStyle = "pointer' ";
    } else {
      var cursorStyle = "default";
    }

    if (this.props.selected == true) {
      if (_.includes(activeTabsList, this.props.menu.key)) {
        var isSelected = "active";
      } else {
        var isSelected = "";
      }
    } else {
      var isSelected = "";
    }

    return (
      <li
        className={"dashboardtop-box " + isSelected}
        onClick={this.onMenuSelected.bind(this)}
        style={{
          width: isTablet ? 215 : 258,
          marginLeft: "10px",
          height: "136px",
          cursor: `${cursorStyle}`,
        }}
      >
        <div className="tabDiv">
          <span className="pull-right iconCircularRight">
            {/* <img
              src={IMAGE_PATH + "/icons/" + this.props.menu.iconName + ".png"}
              className="rounded-circle pull-right"
              alt={this.props.menu.iconName}
            /> */}
            <div className={`icons rounded-circle pull-right`}>
              {AppIcons[this.props.menu.iconName]}
            </div>
          </span>
          <span className="pull-left txtLeft txtLeftSupport">
            <p className="bigNumbers">
              {this.props.counts}{" "}
              {this.props.menu.key == DASHBOARD_ATTEDENGARATE ? "%" : ""}{" "}
            </p>
            <p className="smallTxt">{this.props.menu.sectionName}</p>
          </span>
        </div>
        <div className="analytics-card-lower-div">
          {this.props.userList.length > 0 &&
          (this.props.menu.key == APPUSER_NOT_LOGIN_USERSCOUNT ||
            this.props.menu.key == DASHBOARD_ATTENDEES) ? (
            <>
              <div className="lower_section text-left">
                <p className="smallTxt2">({this.props.menu.sectionDesc})</p>
              </div>

              {/* <div
                className="lower_section text-right custom-text1-theme-medium pointer pr-10"
                onClick={() =>
                  this.openLink(
                    this.props.menu.key,
                    this.props.userList,
                    this.props.counts
                  )
                }
              >
                View List
              </div> */}

              <div className="px-2">
                {this.props.menu.key == APPUSER_NOT_LOGIN_USERSCOUNT ? (
                  <div
                    className="lower_section float-left custom-text1-theme-medium pointer"
                    onClick={() => this.exportUserData()}
                  >
                    {LocaleStrings.export_list}
                  </div>
                ) : (
                  ""
                )}
                <div
                  className="lower_section float-right custom-text1-theme-medium pointer"
                  onClick={() =>
                    this.openLink(
                      this.props.menu.key,
                      this.props.userList,
                      this.props.counts
                    )
                  }
                >
                  {LocaleStrings.view_list}
                </div>
              </div>
            </>
          ) : (
            <span>
              <p className="smallTxt2">({this.props.menu.sectionDesc})</p>
            </span>
          )}
        </div>
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var counts = 0;
  var userList = [];
  switch (ownProps.menu.key) {
    case DASHBOARD_USERSCOUNT:
      counts = state.totalNumberOfUsers ? state.totalNumberOfUsers.count : 0;
      break;
    case DASHBOARD_USERS:
      counts = state.noOfUsersHits ? state.noOfUsersHits.count : 0;
      break;
    case DASHBOARD_DEVICE:
      {
        counts = state.dashboardTotalDevices
          ? state.dashboardTotalDevices.count
          : 0;
      }
      break;
    case DASHBOARD_NETWORKING:
      {
        counts = state.dashboardTotalNetworking
          ? state.dashboardTotalNetworking.count
          : 0;
      }
      break;
    case DASHBOARD_SESSIONS:
      {
        counts = state.dashboardTotalSessions
          ? state.dashboardTotalSessions.count
          : 0;
      }
      break;
    case DASHBOARD_ATTENDEES:
      {
        counts = state.dashboardTotalAttendees
          ? state.dashboardTotalAttendees.count
          : 0;
        userList =
          state.dashboardTotalAttendees &&
          state.dashboardTotalAttendees.userList &&
          state.dashboardTotalAttendees.userList.length > 0
            ? state.dashboardTotalAttendees.userList
            : [];
      }
      break;
    case DASHBOARD_ATTENADOPRATE:
      {
        counts = state.dashboardTotalAttenadoprate
          ? state.dashboardTotalAttenadoprate.count
          : 0;
      }
      break;
    case DASHBOARD_ATTEDENGARATE:
      {
        counts = state.dashboardTotalAttedengaRate
          ? state.dashboardTotalAttedengaRate.count
          : 0;
      }
      break;
    case DASHBOARD_INTERACTION:
      {
        counts = state.dashboardTotalInteractionRate
          ? state.dashboardTotalInteractionRate.count
          : 0;
      }
      break;
    case DASHBOARD_MESSAGESS:
      {
        counts = state.dashboardTotalMessagessCount
          ? state.dashboardTotalMessagessCount.count
          : 0;
      }
      break;
    case APPUSER_NOT_LOGIN_USERSCOUNT:
      {
        counts = state.usernotLoginCount ? state.usernotLoginCount.count : 0;
        userList =
          state.usernotLoginCount &&
          state.usernotLoginCount.userList &&
          state.usernotLoginCount.userList.length > 0
            ? state.usernotLoginCount.userList
            : [];
      }
      break;
    default:
      counts = 0;
      break;
  }
  return {
    dashboardSelectedItem: state.dashboardSelectedItem,
    selected: ownProps.menu.key === state.dashboardSelectedItem,
    counts,
    userList,
    totalUsernotLoginCount: state.totalUsernotLoginCount,
  };
}

export default connect(
  mapStateToProps,
  {
    onDashboardMenuSelected,
    analyticsViewList,
  },
  null,
  { forwardRef: true }
)(DashboardMenuIcon);
